(() => {
  function send(name, params) {
    const payload = Object.assign({ page_location: window.location.href, sm_v2: true }, params || {});
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-sm-v2-tab]');
    if (tab) {
      const list = tab.closest('[role="tablist"]');
      list.querySelectorAll('[role="tab"]').forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      return;
    }
    const link = event.target.closest('[data-sm-v2-event]');
    if (!link) return;
    const name = link.getAttribute('data-sm-v2-event');
    if (name === 'category_card_click') send(name, { category_name: link.getAttribute('data-sm-v2-category') });
    else if (name === 'gallery_product_click') send(name, { product_handle: link.getAttribute('data-sm-v2-product') });
    else if (name === 'hero_cta_click') send(name, { destination: '#hitta-ratt-myra' });
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-sm-v2-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const delta = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(tabs.indexOf(tab) + delta + tabs.length) % tabs.length];
    event.preventDefault();
    next.focus();
    next.click();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form' || !event.cartData || !document.querySelector('.scandmetall-home')) return;
      send('add_to_cart', {
        currency: window.Shopify?.currency?.active || 'SEK',
        value: Number(event.cartData.price || 0) / 100,
        items: [{ item_id: String(event.productVariantId || ''), item_name: event.cartData.title || '', price: Number(event.cartData.price || 0) / 100, quantity: 1 }]
      });
    });
  }
})();